import { GeoJSON } from 'react-leaflet';
import React, { useCallback, useEffect } from 'react';
import { setUserParam } from 'actions';
import { useDispatch } from 'react-redux';
import isNumber from 'lodash/isNumber';
import { mapDataKey } from '../../../utils/map/MapCalculations';
import { getStyle } from '../../../utils/map/MapUtils';

const UndesiredMarkers = ({
  mapData,
  user,
  display,
  routingRoutes,
  highlightStop,
  makeMapMarkers,
}) => {
  const dispatch = useDispatch();
  const handleSetUserParam = useCallback((data) => dispatch(setUserParam(data)), [dispatch]);

  const intersectionCount = routingRoutes.features.filter(
    (f) => f?.properties.isUndesired && f.geometry.type === 'Point',
  )[0]?.properties.intersectionCount;

  const filterMarkersClusterFeatures = useCallback((feature) => {
    return feature.properties.isUndesired && feature.geometry.type === 'Point';
  }, []);
  const clusteredData = useCallback(() => {
    return routingRoutes?.features.filter(
      (f) => f.geometry.type === 'Point' && f.properties.isUndesired,
    );
  }, [routingRoutes]);

  useEffect(() => {
    if (user?.intersectionCount === undefined && isNumber(intersectionCount))
      handleSetUserParam({ intersectionCount });
  }, [handleSetUserParam, user?.intersectionCount, intersectionCount]);

  return (
    <GeoJSON
      key={`${mapDataKey(mapData, user, display, routingRoutes, highlightStop)}-undesired-marker`}
      data={clusteredData()}
      pointToLayer={makeMapMarkers}
      style={getStyle}
      filter={filterMarkersClusterFeatures}
    />
  );
};

export default UndesiredMarkers;
